import type { DeviceStatusType } from '@hivewatch/dark'

import { DeviceStatus } from '@/graphql/generated/schemas'

/**
 * Maps the backend device health enum onto the dark `DeviceStatusIcon` status
 * union. Mirrors the legacy `getDeviceStatusColor` mapping (`@/utils/devices`):
 * Healthy → green, Unhealthy → red, unknown → neutral/amber.
 */
export const getDeviceStatusIconStatus = (
  status?: DeviceStatus | null
): DeviceStatusType => {
  switch (status) {
    case DeviceStatus.Healthy:
      return 'online'
    case DeviceStatus.Unhealthy:
      return 'error'
    default:
      return 'warning'
  }
}
